export default {"src":"/_next/static/media/logo-kijiji.b5f63c82.svg","height":24,"width":48,"blurWidth":0,"blurHeight":0};